import React from 'react'
import PropTypes from 'prop-types'

import SeldonBeattieForm from 'model/wellness/seldonBeattie'
import { Label } from 'pages/Ticket/styled'
import { Input } from 'ui/styled'
import { FormItem } from '../styled'

const SeldonField = ({
  name,
  title,
  placeholder = '',
  type = 'text',
  seldonBeattie,
  updateFn,
  required = false,
  disabled = false
}) => (
  <>
    <Label required={required}>{title}</Label>
    <FormItem
      name={name}
      rules={[{ required, message: `Please enter ${placeholder}` }]}
      onChange={
        seldonBeattie ? e => updateFn(name, e.target.value || null) : undefined
      }
    >
      <Input
        placeholder={placeholder}
        type={type}
        disabled={disabled}
        onWheel={e => e.target.blur()}
        data-test={`${name}_input`}
      />
    </FormItem>
  </>
)

SeldonField.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  seldonBeattie: PropTypes.shape(SeldonBeattieForm.shape).isRequired,
  updateFn: PropTypes.func.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool
}

export default SeldonField
